import { render, staticRenderFns } from "./QuotationDropdown.vue?vue&type=template&id=7b676ec6&"
import script from "./QuotationDropdown.vue?vue&type=script&lang=js&"
export * from "./QuotationDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports